import { EASINGS } from './easings';
import { DURATIONS } from './durations';

const C = DURATIONS.component;
const E = EASINGS.smooth;

export const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: C, ease: E },
  },
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: C, ease: E } },
};

export const staggerContainer = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

export const staggerItem = {
  initial: { opacity: 0, y: 40 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: C, ease: E },
  },
};

export const staggerContainerShow = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

export const staggerItemShow = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: C, ease: E },
  },
};

export const maskReveal = {
  initial: { y: '110%' },
  animate: {
    y: '0%',
    transition: { duration: 0.7, ease: E },
  },
};

export const maskRevealWord = {
  initial: { y: '110%', opacity: 0 },
  animate: {
    y: '0%',
    opacity: 1,
    transition: { duration: 0.65, ease: E },
  },
};